export const TAB_NEAR_CITY = 'near-city';
export const TAB_INDUSTRY_SALARY = 'industry-salary';
export const TAB_INDUSTRY_TREND = 'industry-trend';
export const TAB_INDUSTRY_RATIO = 'industry-ratio';
export const TAB_SALARY_RANK_RATIO = 'salary-rank';
export const TAB_WORK_DISTRIBUTION = 'work-distribution';

export const ERROR_PINYIN = [
  { pinyin: 'chaoyang', errorPinyin: 'zhaoyang' },
  { pinyin: 'luohe', errorPinyin: 'tahe' },
  { pinyin: 'changdu', errorPinyin: 'changdou' },
  { pinyin: 'changzhi', errorPinyin: 'zhangzhi' },
  { pinyin: 'taizhou', errorPinyin: 'tai4zhou' },
  { pinyin: 'fuzhou', errorPinyin: 'fu3zhou' },
  { pinyin: 'suzhou', errorPinyin: 'su1zhou' },
  { pinyin: 'xianggang', errorPinyin: 'xianggangdao' },
];

export const CHECK_PINYIN = [
  { pinyin: 'fu2zhou', checkPinyin: 'fuzhou' },
  { pinyin: 'yi2chun', checkPinyin: 'yichun' },
];

export const NATION_WIDE = { id: 'is_all', name: '全国' };

export const CITIES_LIST = [
  { name: ' 辽源市', pinyin: 'liaoyuan' },
  { name: ' 阿拉善盟', pinyin: 'alashanmeng' },
  { name: ' 抚顺市', pinyin: 'fushun' },
  { name: ' 塔城地区', pinyin: 'tachengdiqu' },
  { name: ' 萍乡市', pinyin: 'pingxiang' },
  { name: ' 沈阳市', pinyin: 'shenyang' },
  { name: ' 阜新市', pinyin: 'fuxin' },
  { name: ' 金普新区', pinyin: 'jinpuxinqu' },
  { name: ' 连江县', pinyin: 'lianjiangxian' },
  { name: ' 嘉义市', pinyin: 'jiayi' },
  { name: ' 白山市', pinyin: 'baishan' },
  { name: ' 昆明市', pinyin: 'kunming' },
  { name: ' 焦作市', pinyin: 'jiaozuo' },
  { name: ' 锦州市', pinyin: 'jinzhou' },
  { name: ' 莱芜市', pinyin: 'laiwu' },
  { name: ' 那曲地区', pinyin: 'naqudiqu' },
  { name: ' 衡阳市', pinyin: 'hengyang' },
  { name: ' 广州市', pinyin: 'guangzhou' },
  { name: ' 东方市', pinyin: 'dongfang' },
  { name: ' 昌江黎族自治县', pinyin: 'changjianglizuzizhixian' },
  { name: ' 韶关市', pinyin: 'shaoguan' },
  { name: ' 万宁市', pinyin: 'wanning' },
  { name: ' 五指山市', pinyin: 'wuzhishan' },
  { name: ' 周口市', pinyin: 'zhoukou' },
  { name: ' 仙桃市', pinyin: 'xiantao' },
  { name: ' 两江新区', pinyin: 'liangjiangxinqu' },
  { name: ' 临高县', pinyin: 'lingaoxian' },
  { name: ' 怀化市', pinyin: 'huaihua' },
  { name: ' 屯昌县', pinyin: 'tunchangxian' },
  { name: ' 保亭黎族苗族自治县', pinyin: 'baotinglizumiaozuzizhixian' },
  { name: ' 文昌市', pinyin: 'wenchang' },
  { name: ' 深圳市', pinyin: 'shenzhen' },
  { name: ' 琼中黎族苗族自治县', pinyin: 'qiongzhonglizumiaozuzizhixian' },
  { name: ' 澎湖县', pinyin: 'penghuxian' },
  { name: ' 台北市', pinyin: 'taibei' },
  { name: ' 花莲县', pinyin: 'hualianxian' },
  { name: ' 氹仔岛', pinyin: 'dangzaidao' },
  { name: ' 哈密地区', pinyin: 'hamidiqu' },
  { name: ' 高雄市', pinyin: 'gaoxiong' },
  { name: ' 双河市', pinyin: 'shuanghe' },
  { name: ' 金门县', pinyin: 'jinmenxian' },
  { name: ' 新竹县', pinyin: 'xinzhuxian' },
  { name: ' 九龙', pinyin: 'jiulong' },
  { name: ' 图木舒克市', pinyin: 'tumushuke' },
  { name: ' 宜兰县', pinyin: 'yilanxian' },
  { name: ' 乐东黎族自治县', pinyin: 'ledonglizuzizhixian' },
  { name: ' 桃园县', pinyin: 'taoyuanxian' },
  { name: ' 新北市', pinyin: 'xinbei' },
  { name: ' 玉树藏族自治州', pinyin: 'yushuzangzuzizhizhou' },
  { name: ' 台中市', pinyin: 'taizhong' },
  { name: ' 五家渠市', pinyin: 'wujiaqu' },
  { name: ' 新竹市', pinyin: 'xinzhu' },
  { name: ' 香港岛', pinyin: 'xianggang' },
  { name: ' 中卫市', pinyin: 'zhongwei' },
  { name: ' 基隆市', pinyin: 'jilong' },
  { name: ' 路环岛', pinyin: 'luhuandao' },
  { name: ' 昭通市', pinyin: 'zhaotong' },
  { name: ' 东营市', pinyin: 'dongying' },
  { name: ' 琼海市', pinyin: 'qionghai' },
  { name: ' 泉州市', pinyin: 'quanzhou' },
  { name: ' 锡林郭勒盟', pinyin: 'xilinguoleimeng' },
  { name: ' 儋州市', pinyin: 'danzhou' },
  { name: ' 克拉玛依市', pinyin: 'kelamayi' },
  { name: ' 内江市', pinyin: 'neijiang' },
  { name: ' 山南地区', pinyin: 'shannandiqu' },
  { name: ' 漳州市', pinyin: 'zhangzhou' },
  { name: ' 防城港市', pinyin: 'fangchenggang' },
  { name: ' 漯河市', pinyin: 'luohe' },
  { name: ' 石河子市', pinyin: 'shihezi' },
  { name: ' 大兴安岭地区', pinyin: 'daxinganlingdiqu' },
  { name: ' 苗栗县', pinyin: 'miaolixian' },
  { name: ' 文山壮族苗族自治州', pinyin: 'wenshanzhuangzumiaozuzizhizhou' },
  { name: ' 云浮市', pinyin: 'yunfu' },
  { name: ' 蚌埠市', pinyin: 'bengbu' },
  { name: ' 陇南市', pinyin: 'longnan' },
  { name: ' 西咸新区', pinyin: 'xixianxinqu' },
  { name: ' 大连市', pinyin: 'dalian' },
  { name: ' 驻马店市', pinyin: 'zhumadian' },
  { name: ' 烟台市', pinyin: 'yantai' },
  { name: ' 中山市', pinyin: 'zhongshan' },
  { name: ' 宿迁市', pinyin: 'suqian' },
  { name: ' 铁岭市', pinyin: 'tieling' },
  { name: ' 乐山市', pinyin: 'leshan' },
  { name: ' 九江市', pinyin: 'jiujiang' },
  { name: ' 承德市', pinyin: 'chengde' },
  { name: ' 喀什地区', pinyin: 'kashidiqu' },
  { name: ' 遂宁市', pinyin: 'suining' },
  { name: ' 泸州市', pinyin: 'luzhou' },
  { name: ' 绥化市', pinyin: 'suihua' },
  { name: ' 马鞍山市', pinyin: 'maanshan' },
  { name: ' 海口市', pinyin: 'haikou' },
  { name: ' 彰化县', pinyin: 'zhanghuaxian' },
  { name: ' 丽江市', pinyin: 'lijiang' },
  { name: ' 克孜勒苏柯尔克孜自治州', pinyin: 'kezileisukeerkezizizhizhou' },
  { name: ' 廊坊市', pinyin: 'langfang' },
  { name: ' 澳门半岛', pinyin: 'aomenbandao' },
  { name: ' 莆田市', pinyin: 'putian' },
  { name: ' 东莞市', pinyin: 'dongguan' },
  { name: ' 新界', pinyin: 'xinjie' },
  { name: ' 扬州市', pinyin: 'yangzhou' },
  { name: ' 赣州市', pinyin: 'ganzhou' },
  { name: ' 甘南藏族自治州', pinyin: 'gannanzangzuzizhizhou' },
  { name: ' 泰州市', pinyin: 'taizhou' },
  { name: ' 滁州市', pinyin: 'chuzhou' },
  { name: ' 朝阳市', pinyin: 'chaoyang' },
  { name: ' 日照市', pinyin: 'rizhao' },
  { name: ' 朔州市', pinyin: 'shuozhou' },
  { name: ' 拉萨市', pinyin: 'lasa' },
  { name: ' 嘉峪关市', pinyin: 'jiayuguan' },
  { name: ' 白沙黎族自治县', pinyin: 'baishalizuzizhixian' },
  { name: ' 四平市', pinyin: 'siping' },
  { name: ' 张家口市', pinyin: 'zhangjiakou' },
  { name: ' 葫芦岛市', pinyin: 'huludao' },
  { name: ' 南阳市', pinyin: 'nanyang' },
  { name: ' 红河哈尼族彝族自治州', pinyin: 'honghehanizuyizuzizhizhou' },
  { name: ' 徐州市', pinyin: 'xuzhou' },
  { name: ' 三门峡市', pinyin: 'sanmenxia' },
  { name: ' 鄂尔多斯市', pinyin: 'eerduosi' },
  { name: ' 滨州市', pinyin: 'binzhou' },
  { name: ' 自贡市', pinyin: 'zigong' },
  { name: ' 合肥市', pinyin: 'hefei' },
  { name: ' 吐鲁番地区', pinyin: 'tulufandiqu' },
  { name: ' 白城市', pinyin: 'baicheng' },
  { name: ' 大理白族自治州', pinyin: 'dalibaizuzizhizhou' },
  { name: ' 盘锦市', pinyin: 'panjin' },
  { name: ' 鸡西市', pinyin: 'jixi' },
  { name: ' 雅安市', pinyin: 'yaan' },
  { name: ' 乌兰察布市', pinyin: 'wulanchabu' },
  { name: ' 铜陵市', pinyin: 'tongling' },
  { name: ' 运城市', pinyin: 'yuncheng' },
  { name: ' 伊春市', pinyin: 'yichun' },
  { name: ' 甘孜藏族自治州', pinyin: 'ganzizangzuzizhizhou' },
  { name: ' 眉山市', pinyin: 'meishan' },
  { name: ' 酒泉市', pinyin: 'jiuquan' },
  { name: ' 济南市', pinyin: 'jinan' },
  { name: ' 鞍山市', pinyin: 'anshan' },
  { name: ' 柳州市', pinyin: 'liuzhou' },
  { name: ' 秦皇岛市', pinyin: 'qinhuangdao' },
  { name: ' 渭南市', pinyin: 'weinan' },
  { name: ' 宜宾市', pinyin: 'yibin' },
  { name: ' 邯郸市', pinyin: 'handan' },
  { name: ' 武威市', pinyin: 'wuwei' },
  { name: ' 张家界市', pinyin: 'zhangjiajie' },
  { name: ' 咸阳市', pinyin: 'xianyang' },
  { name: ' 亳州市', pinyin: 'bozhou' },
  { name: ' 镇江市', pinyin: 'zhenjiang' },
  { name: ' 神农架林区', pinyin: 'shennongjialinqu' },
  { name: ' 丽水市', pinyin: 'lishui' },
  { name: ' 德阳市', pinyin: 'deyang' },
  { name: ' 鹤岗市', pinyin: 'hegang' },
  { name: ' 株洲市', pinyin: 'zhuzhou' },
  { name: ' 潮州市', pinyin: 'chaozhou' },
  { name: ' 随州市', pinyin: 'suizhou' },
  { name: ' 通化市', pinyin: 'tonghua' },
  { name: ' 铜川市', pinyin: 'tongchuan' },
  { name: ' 舟山市', pinyin: 'zhoushan' },
  { name: ' 黑河市', pinyin: 'heihe' },
  { name: ' 海东市', pinyin: 'haidong' },
  { name: ' 宣城市', pinyin: 'xuancheng' },
  { name: ' 宜昌市', pinyin: 'yichang' },
  { name: ' 庆阳市', pinyin: 'qingyang' },
  { name: ' 南投县', pinyin: 'nantouxian' },
  { name: ' 抚州市', pinyin: 'fuzhou' },
  { name: ' 鹰潭市', pinyin: 'yingtan' },
  { name: ' 双鸭山市', pinyin: 'shuangyashan' },
  { name: ' 淮南市', pinyin: 'huainan' },
  { name: ' 怒江傈僳族自治州', pinyin: 'nujianglisuzuzizhizhou' },
  { name: ' 南充市', pinyin: 'nanchong' },
  { name: ' 黄冈市', pinyin: 'huanggang' },
  { name: ' 南昌市', pinyin: 'nanchang' },
  { name: ' 吉安市', pinyin: 'jian' },
  { name: ' 南宁市', pinyin: 'nanning' },
  { name: ' 石家庄市', pinyin: 'shijiazhuang' },
  { name: ' 湖州市', pinyin: 'huzhou' },
  { name: ' 沧州市', pinyin: 'cangzhou' },
  { name: ' 汕头市', pinyin: 'shantou' },
  { name: ' 苏州市', pinyin: 'suzhou' },
  { name: ' 晋中市', pinyin: 'jinzhong' },
  { name: ' 阿拉尔市', pinyin: 'alaer' },
  { name: ' 黄南藏族自治州', pinyin: 'huangnanzangzuzizhizhou' },
  { name: ' 杭州市', pinyin: 'hangzhou' },
  { name: ' 洛阳市', pinyin: 'luoyang' },
  { name: ' 通辽市', pinyin: 'tongliao' },
  { name: ' 嘉义县', pinyin: 'jiayixian' },
  { name: ' 绍兴市', pinyin: 'shaoxing' },
  { name: ' 益阳市', pinyin: 'yiyang' },
  { name: ' 铜仁市', pinyin: 'tongren' },
  { name: ' 海南藏族自治州', pinyin: 'hainanzangzuzizhizhou' },
  { name: ' 厦门市', pinyin: 'xiamen' },
  { name: ' 汕尾市', pinyin: 'shanwei' },
  { name: ' 河源市', pinyin: 'heyuan' },
  { name: ' 长春市', pinyin: 'changchun' },
  { name: ' 临沂市', pinyin: 'linyi' },
  { name: ' 迪庆藏族自治州', pinyin: 'diqingzangzuzizhizhou' },
  { name: ' 三沙市', pinyin: 'sansha' },
  { name: ' 阳江市', pinyin: 'yangjiang' },
  { name: ' 济源市', pinyin: 'jiyuan' },
  { name: ' 遵义市', pinyin: 'zunyi' },
  { name: ' 攀枝花市', pinyin: 'panzhihua' },
  { name: ' 长沙市', pinyin: 'changsha' },
  { name: ' 潜江市', pinyin: 'qianjiang' },
  { name: ' 贵阳市', pinyin: 'guiyang' },
  { name: ' 芜湖市', pinyin: 'wuhu' },
  { name: ' 牡丹江市', pinyin: 'mudanjiang' },
  { name: ' 大庆市', pinyin: 'daqing' },
  { name: ' 澄迈县', pinyin: 'chengmaixian' },
  { name: ' 上海市', pinyin: 'shanghai' },
  { name: ' 宝鸡市', pinyin: 'baoji' },
  { name: ' 平顶山市', pinyin: 'pingdingshan' },
  { name: ' 本溪市', pinyin: 'benxi' },
  { name: ' 吕梁市', pinyin: 'lvliang' },
  { name: ' 温州市', pinyin: 'wenzhou' },
  { name: ' 阳泉市', pinyin: 'yangquan' },
  { name: ' 西安市', pinyin: 'xian' },
  { name: ' 湘西土家族苗族自治州', pinyin: 'xiangxitujiazumiaozuzizhizhou' },
  { name: ' 六安市', pinyin: 'luan' },
  { name: ' 安康市', pinyin: 'ankang' },
  { name: ' 鄂州市', pinyin: 'ezhou' },
  { name: ' 定西市', pinyin: 'dingxi' },
  { name: ' 茂名市', pinyin: 'maoming' },
  { name: ' 崇左市', pinyin: 'chongzuo' },
  { name: ' 成都市', pinyin: 'chengdu' },
  { name: ' 吉林市', pinyin: 'jilin' },
  { name: ' 北海市', pinyin: 'beihai' },
  { name: ' 巴音郭楞蒙古自治州', pinyin: 'bayinguolengmengguzizhizhou' },
  { name: ' 资阳市', pinyin: 'ziyang' },
  { name: ' 定安县', pinyin: 'dinganxian' },
  { name: ' 日喀则市', pinyin: 'rikaze' },
  { name: ' 三明市', pinyin: 'sanming' },
  { name: ' 衡水市', pinyin: 'hengshui' },
  { name: ' 信阳市', pinyin: 'xinyang' },
  { name: ' 三亚市', pinyin: 'sanya' },
  { name: ' 珠海市', pinyin: 'zhuhai' },
  { name: ' 云林县', pinyin: 'yunlinxian' },
  { name: ' 绵阳市', pinyin: 'mianyang' },
  { name: ' 贵港市', pinyin: 'guigang' },
  { name: ' 重庆市', pinyin: 'chongqing' },
  { name: ' 宁波市', pinyin: 'ningbo' },
  { name: ' 呼和浩特市', pinyin: 'huhehaote' },
  { name: ' 泰安市', pinyin: 'taian' },
  { name: ' 福州市', pinyin: 'fu2zhou' },
  { name: ' 保定市', pinyin: 'baoding' },
  { name: ' 湛江市', pinyin: 'zhanjiang' },
  { name: ' 阿克苏地区', pinyin: 'akesudiqu' },
  { name: ' 荆州市', pinyin: 'jingzhou' },
  { name: ' 呼伦贝尔市', pinyin: 'hulunbeier' },
  { name: ' 辽阳市', pinyin: 'liaoyang' },
  { name: ' 嘉兴市', pinyin: 'jiaxing' },
  { name: ' 湘潭市', pinyin: 'xiangtan' },
  { name: ' 齐齐哈尔市', pinyin: 'qiqihaer' },
  { name: ' 广安市', pinyin: 'guangan' },
  { name: ' 龙岩市', pinyin: 'longyan' },
  { name: ' 西宁市', pinyin: 'xining' },
  { name: ' 玉溪市', pinyin: 'yuxi' },
  { name: ' 安庆市', pinyin: 'anqing' },
  { name: ' 常德市', pinyin: 'changde' },
  { name: ' 赤峰市', pinyin: 'chifeng' },
  { name: ' 兰州市', pinyin: 'lanzhou' },
  { name: ' 郑州市', pinyin: 'zhengzhou' },
  { name: ' 景德镇市', pinyin: 'jingdezhen' },
  { name: ' 新余市', pinyin: 'xinyu' },
  { name: ' 金昌市', pinyin: 'jinchang' },
  { name: ' 唐山市', pinyin: 'tangshan' },
  { name: ' 临沧市', pinyin: 'lincang' },
  { name: ' 包头市', pinyin: 'baotou' },
  { name: ' 河池市', pinyin: 'hechi' },
  { name: ' 天门市', pinyin: 'tianmen' },
  { name: ' 天津市', pinyin: 'tianjin' },
  { name: ' 兴安盟', pinyin: 'xinganmeng' },
  { name: ' 临夏回族自治州', pinyin: 'linxiahuizuzizhizhou' },
  { name: ' 榆林市', pinyin: 'yulin' },
  { name: ' 咸宁市', pinyin: 'xianning' },
  { name: ' 昌吉回族自治州', pinyin: 'changjihuizuzizhizhou' },
  { name: ' 武汉市', pinyin: 'wuhan' },
  { name: ' 吴忠市', pinyin: 'wuzhong' },
  { name: ' 连云港市', pinyin: 'lianyungang' },
  { name: ' 台南市', pinyin: 'tainan' },
  { name: ' 延安市', pinyin: 'yanan' },
  { name: ' 常州市', pinyin: 'changzhou' },
  { name: ' 百色市', pinyin: 'baise' },
  { name: ' 商丘市', pinyin: 'shangqiu' },
  { name: ' 南京市', pinyin: 'nanjing' },
  { name: ' 巴中市', pinyin: 'bazhong' },
  { name: ' 盐城市', pinyin: 'yancheng' },
  { name: ' 丹东市', pinyin: 'dandong' },
  { name: ' 宁德市', pinyin: 'ningde' },
  { name: ' 岳阳市', pinyin: 'yueyang' },
  { name: ' 襄阳市', pinyin: 'xiangyang' },
  { name: ' 清远市', pinyin: 'qingyuan' },
  { name: ' 延边朝鲜族自治州', pinyin: 'yanbianchaoxianzuzizhizhou' },
  { name: ' 北京市', pinyin: 'beijing' },
  { name: ' 忻州市', pinyin: 'xinzhou' },
  { name: ' 荆门市', pinyin: 'jingmen' },
  { name: ' 阿里地区', pinyin: 'alidiqu' },
  { name: ' 南通市', pinyin: 'nantong' },
  { name: ' 台州市', pinyin: 'tai1zhou' },
  { name: ' 邵阳市', pinyin: 'shaoyang' },
  { name: ' 达州市', pinyin: 'dazhou' },
  { name: ' 菏泽市', pinyin: 'heze' },
  { name: ' 新乡市', pinyin: 'xinxiang' },
  { name: ' 聊城市', pinyin: 'liaocheng' },
  { name: ' 固原市', pinyin: 'guyuan' },
  { name: ' 安阳市', pinyin: 'anyang' },
  { name: ' 平凉市', pinyin: 'pingliang' },
  { name: ' 揭阳市', pinyin: 'jieyang' },
  { name: ' 营口市', pinyin: 'yingkou' },
  { name: ' 许昌市', pinyin: 'xuchang' },
  { name: ' 七台河市', pinyin: 'qitaihe' },
  { name: ' 陵水黎族自治县', pinyin: 'lingshuilizuzizhixian' },
  { name: ' 保山市', pinyin: 'baoshan' },
  { name: ' 南平市', pinyin: 'nanping' },
  { name: ' 大同市', pinyin: 'datong' },
  { name: ' 阿坝藏族羌族自治州', pinyin: 'abazangzuqiangzuzizhizhou' },
  { name: ' 安顺市', pinyin: 'anshun' },
  { name: ' 铁门关市', pinyin: 'tiemenguan' },
  { name: ' 海西蒙古族藏族自治州', pinyin: 'haiximengguzuzangzuzizhizhou' },
  { name: ' 上饶市', pinyin: 'shangrao' },
  { name: ' 宿州市', pinyin: 'su4zhou' },
  { name: ' 池州市', pinyin: 'chizhou' },
  { name: ' 淮北市', pinyin: 'huaibei' },
  { name: ' 哈尔滨市', pinyin: 'haerbin' },
  { name: ' 来宾市', pinyin: 'laibin' },
  { name: ' 江门市', pinyin: 'jiangmen' },
  { name: ' 阿勒泰地区', pinyin: 'aleitaidiqu' },
  { name: ' 濮阳市', pinyin: 'puyang' },
  { name: ' 邢台市', pinyin: 'xingtai' },
  { name: ' 临汾市', pinyin: 'linfen' },
  { name: ' 海北藏族自治州', pinyin: 'haibeizangzuzizhizhou' },
  { name: ' 白银市', pinyin: 'baiyin' },
  { name: ' 石嘴山市', pinyin: 'shizuishan' },
  { name: ' 贺州市', pinyin: 'hezhou' },
  { name: ' 淄博市', pinyin: 'zibo' },
  { name: ' 青岛市', pinyin: 'qingdao' },
  { name: ' 威海市', pinyin: 'weihai' },
  { name: ' 惠州市', pinyin: 'huizhou' },
  { name: ' 梅州市', pinyin: 'meizhou' },
  { name: ' 台东县', pinyin: 'taidongxian' },
  { name: ' 商洛市', pinyin: 'shangluo' },
  { name: ' 孝感市', pinyin: 'xiaogan' },
  { name: ' 昌都市', pinyin: 'changdu' },
  { name: ' 天水市', pinyin: 'tianshui' },
  { name: ' 娄底市', pinyin: 'loudi' },
  { name: ' 阜阳市', pinyin: 'fuyang' },
  { name: ' 鹤壁市', pinyin: 'hebi' },
  { name: ' 和田地区', pinyin: 'hetiandiqu' },
  { name: ' 屏东县', pinyin: 'pingdongxian' },
  { name: ' 开封市', pinyin: 'kaifeng' },
  { name: ' 汉中市', pinyin: 'hanzhong' },
  { name: ' 桂林市', pinyin: 'guilin' },
  { name: ' 伊犁哈萨克自治州', pinyin: 'yilihasakezizhizhou' },
  { name: ' 佳木斯市', pinyin: 'jiamusi' },
  { name: ' 林芝地区', pinyin: 'linzhidiqu' },
  { name: ' 黄石市', pinyin: 'huangshi' },
  { name: ' 十堰市', pinyin: 'shiyan' },
  { name: ' 普洱市', pinyin: 'puer' },
  { name: ' 黔南布依族苗族自治州', pinyin: 'qiannanbuyizumiaozuzizhizhou' },
  { name: ' 巴彦淖尔市', pinyin: 'bayannaoer' },
  { name: ' 张掖市', pinyin: 'zhangye' },
  { name: ' 钦州市', pinyin: 'qinzhou' },
  { name: ' 楚雄彝族自治州', pinyin: 'chuxiongyizuzizhizhou' },
  { name: ' 乌海市', pinyin: 'wuhai' },
  { name: ' 果洛藏族自治州', pinyin: 'guoluozangzuzizhizhou' },
  { name: ' 博尔塔拉蒙古自治州', pinyin: 'boertalamengguzizhizhou' },
  { name: ' 乌鲁木齐市', pinyin: 'wulumuqi' },
  { name: ' 黔西南布依族苗族自治州', pinyin: 'qianxinanbuyizumiaozuzizhizhou' },
  { name: ' 郴州市', pinyin: 'chenzhou' },
  { name: ' 黔东南苗族侗族自治州', pinyin: 'qiandongnanmiaozudongzuzizhizhou' },
  { name: ' 松原市', pinyin: 'songyuan' },
  { name: ' 六盘水市', pinyin: 'liupanshui' },
  { name: ' 长治市', pinyin: 'changzhi' },
  { name: ' 济宁市', pinyin: 'jining' },
  { name: ' 衢州市', pinyin: 'quzhou' },
  { name: ' 凉山彝族自治州', pinyin: 'liangshanyizuzizhizhou' },
  { name: ' 无锡市', pinyin: 'wuxi' },
  { name: ' 广元市', pinyin: 'guangyuan' },
  { name: ' 梧州市', pinyin: 'wuzhou' },
  { name: ' 北屯市', pinyin: 'beitun' },
  { name: ' 枣庄市', pinyin: 'zaozhuang' },
  { name: ' 银川市', pinyin: 'yinchuan' },
  { name: ' 玉林市', pinyin: 'yu4lin' },
  { name: ' 德州市', pinyin: 'dezhou' },
  { name: ' 永州市', pinyin: 'yongzhou' },
  { name: ' 佛山市', pinyin: 'foshan' },
  { name: ' 太原市', pinyin: 'taiyuan' },
  { name: ' 肇庆市', pinyin: 'zhaoqing' },
  { name: ' 黄山市', pinyin: 'huangshan' },
  { name: ' 金华市', pinyin: 'jinhua' },
  { name: ' 恩施土家族苗族自治州', pinyin: 'enshitujiazumiaozuzizhizhou' },
  { name: ' 德宏傣族景颇族自治州', pinyin: 'dehongdaizujingpozuzizhizhou' },
  { name: ' 西双版纳傣族自治州', pinyin: 'xishuangbannadaizuzizhizhou' },
  { name: ' 舟山群岛新区', pinyin: 'zhoushanqundaoxinqu' },
  { name: ' 淮安市', pinyin: 'huaian' },
  { name: ' 宜春市', pinyin: 'yi2chun' },
  { name: ' 毕节市', pinyin: 'bijie' },
  { name: ' 曲靖市', pinyin: 'qujing' },
  { name: ' 晋城市', pinyin: 'jincheng' },
  { name: ' 潍坊市', pinyin: 'weifang' },
];
